import { Dialog, IconButton } from "@mui/material";
import { MdClose } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { CurrencyIcon } from "../../../../Components/Atoms/CurrencyIcon";
import { SummaryCardSkeleton } from "../../../../Components/Molecules/DashboardSkeleton";
import { contaInternacionalCurrencyPath, formatCurrencyAmount } from "../constants";

const MODAL_PAPER_CLASS = "!rounded-2xl !shadow-card app-card !m-4 !flex !flex-col !max-h-[90vh]";

const ROW_GRID =
  "sm:grid sm:grid-cols-[minmax(0,1.4fr)_repeat(3,minmax(0,1fr))] sm:items-center sm:gap-x-4";

const CurrencyRow = ({ currency, onSelect }) => (
  <button
    type="button"
    onClick={() => onSelect(currency.id)}
    className={`flex w-full flex-col gap-2.5 rounded-xl border border-gray-200 px-3.5 py-3 text-left transition-colors hover:border-[#e7a73f]/40 hover:bg-[#fff8ec]/30 dark:border-brand-dark-border dark:hover:bg-white/5 ${ROW_GRID}`}
  >
    <div className="flex min-w-0 items-center gap-2.5">
      <CurrencyIcon asset={currency.id} />
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold text-brand-dark">{currency.label}</p>
        <p className="text-xs text-gray-500">{currency.code}</p>
      </div>
    </div>

    <div className="flex items-center justify-between gap-3 sm:block sm:text-right">
      <p className="text-[10px] font-medium uppercase tracking-wide text-gray-400 sm:hidden">
        Disponível
      </p>
      <p className="text-sm font-semibold text-brand-dark">
        {formatCurrencyAmount(currency.balance, currency.id)}
      </p>
    </div>

    <div className="flex items-center justify-between gap-3 sm:block sm:text-right">
      <p className="text-[10px] font-medium uppercase tracking-wide text-gray-400 sm:hidden">
        Bloqueado
      </p>
      <p className="text-sm font-semibold text-gray-600 dark:text-gray-300">
        {formatCurrencyAmount(currency.blockedBalance, currency.id)}
      </p>
    </div>

    <div className="flex items-center justify-between gap-3 sm:block sm:text-right">
      <p className="text-[10px] font-medium uppercase tracking-wide text-gray-400 sm:hidden">
        Limite
      </p>
      <p className="text-sm font-semibold text-gray-600 dark:text-gray-300">
        {formatCurrencyAmount(currency.limit, currency.id)}
      </p>
    </div>
  </button>
);

export const ContaInternacionalTodasMoedasModal = ({
  open,
  onClose,
  currencies = [],
  loading = false,
}) => {
  const history = useHistory();

  const handleSelect = (currencyId) => {
    onClose();
    history.push(contaInternacionalCurrencyPath(currencyId));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ className: MODAL_PAPER_CLASS }}
    >
      <div className="relative flex min-h-0 flex-1 flex-col">
        <IconButton
          aria-label="Fechar"
          onClick={onClose}
          size="small"
          className="!absolute !right-3 !top-3 !z-10"
        >
          <MdClose />
        </IconButton>

        <div className="flex-1 overflow-y-auto px-5 pt-6 sm:px-6">
          <h2 className="pr-8 text-lg font-bold text-brand-dark">Todas as moedas</h2>
          <p className="mt-1 text-sm text-gray-500">
            Saldos disponíveis, bloqueados e limites por moeda.
          </p>

          <div
            className={`mt-4 hidden px-3.5 text-[10px] font-semibold uppercase tracking-wider text-gray-400 ${ROW_GRID}`}
          >
            <span>Moeda</span>
            <span className="text-right">Disponível</span>
            <span className="text-right">Bloqueado</span>
            <span className="text-right">Limite</span>
          </div>

          <div className="mt-2 space-y-2">
            {loading && !currencies.length
              ? Array.from({ length: 4 }).map((_, index) => (
                  <SummaryCardSkeleton key={index} />
                ))
              : currencies.length
                ? currencies.map((currency) => (
                    <CurrencyRow
                      key={currency.id}
                      currency={currency}
                      onSelect={handleSelect}
                    />
                  ))
                : (
                  <p className="px-1 py-6 text-sm text-gray-500">
                    Nenhum saldo multicurrency nesta conta.
                  </p>
                )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};
